import { MERCHANT_IDS_WITHOUT_PRODUCTS_MENU } from '@core/constants/merchant-menu-exclusions';
import {
  ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
  ROUTE_PRIVILEGES_INTEGRATION,
  ROUTE_PRIVILEGES_SALES_CHANNELS,
  ROUTE_PRIVILEGES_ORDERS,
  ROUTE_PRIVILEGES_USERS,
} from '@core/constants/merchant-route-privileges';
import type { MenuItemType } from '@shared/types/layout';

interface UserDropdownItemType {
  label?: string;
  icon?: string;
  url?: string;
  isDivider?: boolean;
  isHeader?: boolean;
  class?: string;
}

export const userDropdownItems: UserDropdownItemType[] = [
  {
    label: 'Welcome back!',
    isHeader: true,
  },
  {
    label: 'Profile',
    icon: 'tablerUserCircle',
    url: 'pages-profile.html',
  },
  {
    label: 'Notifications',
    icon: 'tablerBellRinging',
    url: '#',
  },
  {
    label: 'Balance: $985.25',
    icon: 'tablerCreditCard',
    url: '#',
  },
  {
    label: 'Account Settings',
    icon: 'tablerSettings2',
    url: '#',
  },
  {
    label: 'Support Center',
    icon: 'tablerHeadset',
    url: '#',
  },
  {
    isDivider: true,
  },
  {
    label: 'Lock Screen',
    icon: 'tablerLock',
    url: 'auth-lock-screen.html',
  },
  {
    label: 'Log Out',
    icon: 'tablerLogout2',
    url: '#',
    class: 'fw-semibold',
  },
];

export const menuItems: MenuItemType[] = [
  // {
  //   label: 'menu.dashboard',
  //   icon: icons.dashboard,
  //   url: '/dashboard',
  // },

  { label: 'menu.commerce', isTitle: true },
  {
    label: 'menu.orders',
    icon: 'orders',
    url: '/orders',
    requiredPrivileges: ROUTE_PRIVILEGES_ORDERS,
  },
  {
    label: 'menu.claims_returns',
    icon: 'claimsReturns',
    url: '/returns',
    requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
  },

  { label: 'menu.finances', isTitle: true },
  {
    label: 'menu.settlements',
    icon: 'pspsettlements',
    url: '/settlements',
    requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
  },
  {
    label: 'menu.invoices',
    icon: 'bankledger',
    url: '/invoices',
    requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
  },
  {
    label: 'menu.wallets',
    icon: 'wallet',
    url: '/wallets',
    requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
  },

  { label: 'menu.settings_section', isTitle: true },
  {
    label: 'menu.sales_channels',
    icon: 'partners',
    url: '/sales-channels',
    requiredPrivileges: ROUTE_PRIVILEGES_SALES_CHANNELS,
  },
  {
    label: 'menu.products',
    icon: 'products',
    url: '/products',
    requiredPrivileges: ROUTE_PRIVILEGES_FINANCE_AND_RETURNS,
    hiddenForMerchantIds: MERCHANT_IDS_WITHOUT_PRODUCTS_MENU,
  },

  { label: 'menu.other', isTitle: true },
  {
    label: 'menu.users',
    icon: 'person',
    url: '/users',
    requiredPrivileges: ROUTE_PRIVILEGES_USERS,
  },
  {
    label: 'menu.logs',
    icon: 'logs',
    url: '/integration-profiles-logs',
    requiredPrivileges: ROUTE_PRIVILEGES_INTEGRATION,
  },
];
